import { createSelector } from "reselect";

export const selectApplicationState = createSelector(
  state => state,
  state => state?.ApplicationsReducers
);

export const selectCurrentApplication = createSelector(
  selectApplicationState,
  state => state?.application
);

export const selectCurrentApplicationData = createSelector(
  selectApplicationState,
  state => state?.application?.data?.personData
);

export const selectCurrentApplicationState = createSelector(
  selectCurrentApplication,
  state => state?.state
);

export const selectCurrentApplicationEsgRiskLevel = createSelector(
  selectCurrentApplication,
  state => state?.esgRiskLevel
);

export const selectCurrentApplicationId = createSelector(
  selectCurrentApplication,
  state => state?.id
);

export const selectCurrentApplicationActions = createSelector(
  selectCurrentApplication,
  state => state?.actions || []
);

export const selectApplicationGeneralInfo = createSelector(
  selectCurrentApplication,
  state => ({
    clientName: state?.clientName,
    currentState: state?.state,
    currentStatus: state?.status,
    code: state?.clientCode
  })
);

export const selectApplicationDocuments = createSelector(
  selectCurrentApplication,
  state => state?.documents || []
);

export const selectApplicationComments = createSelector(
  selectCurrentApplication,
  state => state?.comments || []
);

export const selectAppRiskTotalScore = createSelector(
  selectCurrentApplication,
  state => state?.risks?.totalScore
);

export const selectSanctionList = createSelector(
  selectApplicationState,
  state => state?.sanctionsList || []
);

export const selectRiskManualList = createSelector(
  selectApplicationState,
  state => state?.manualRiskList || []
);

export const selectAppRisksList = createSelector(
  selectApplicationState,
  state => state?.applicationRisksList || {}
);

// -----> LOADERS
export const selectIsAddRiskLoading = createSelector(
  selectApplicationState,
  state => state?.isAddRiskLoading || false
);

export const selectIsRiskUpdateLoading = createSelector(
  selectApplicationState,
  state => state?.isRiskUpdateLoading || false
);

export const selectAppRisksListLoading = createSelector(
  selectApplicationState,
  state => state?.isClientRisksListLoading || false
);

export const selectIsApproveBenefecieresLoading = createSelector(
  selectApplicationState,
  state => state?.isApproveBeneficiaresLoading || false
);

export const selectIsRequestAdditionaDocsLoading = createSelector(
  selectApplicationState,
  state => state?.isRequestAdditionaoDocsLoading || false
);

export const selectIsReviewKycLoading = createSelector(
  selectApplicationState,
  state => state?.isReviewKycStatusLoading || false
);

export const selectIsRejectLoading = createSelector(
  selectApplicationState,
  state => state?.isRejectAppLoading || false
);

export const selectRejectUploadedAgreementLoading = createSelector(
  selectApplicationState,
  state => state?.isRejectUploadedAgreementLoading || false
);

export const isReqAdditionalDocsLoading = createSelector(
  selectApplicationState,
  state => state?.isRequestAdditionaDocsLoading || false
);

export const selectIsSanctionsLoading = createSelector(
  selectApplicationState,
  state => state?.isLoadingSanctions || false
);

export const selectIsUploadingDocs = createSelector(
  selectApplicationState,
  state => state?.isUploadingAppDocuments || false
);

export const selectIsSendApplication = createSelector(
  selectApplicationState,
  state => state?.sendApplication || false
);

export const selectIsReviewSanctionsLoading = createSelector(
  selectApplicationState,
  state => state?.isReviewSanctionLoading || false
);

export const selectIsSendSanctionLoading = createSelector(
  selectApplicationState,
  state => state?.sendSanctions || false
);

export const selectIsAddRiskModalLoading = createSelector(
  selectIsAddRiskLoading,
  selectIsSendApplication,
  (riskLoader, sendAppLoader) => riskLoader || sendAppLoader
);

export const selectIsReviewSanctionModalLoading = createSelector(
  selectIsReviewSanctionsLoading,
  selectIsSendSanctionLoading,
  (reviewSanctionLoader, sendSanctionLoader) => reviewSanctionLoader || sendSanctionLoader
);
// <----- LOADERS
